export * from './post-zeit-art.service';
export * from './post-zeit-art.service.module';